import { render, staticRenderFns } from "./ProjectFormModal.vue?vue&type=template&id=bdfd39a6&scoped=true"
import script from "./ProjectFormModal.vue?vue&type=script&lang=js"
export * from "./ProjectFormModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectFormModal.vue?vue&type=style&index=0&id=bdfd39a6&prod&lang=scss"
import style1 from "./ProjectFormModal.vue?vue&type=style&index=1&id=bdfd39a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfd39a6",
  null
  
)

export default component.exports